import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Navbar from "../../../../Components/Navbar";
import { fetchProfile } from "../../../../services/profileService";
import {
  fetchRawData,
  fetchPeriod,
  fetchMarketBreakDown,
  fetchLevel,
  fetchFact,
  fetchTypeProjectNew,
} from "../../../../services/reportDBRawDataService";
import {
  setSelectedPeriod,
  setSelectedMarketBreakDown,
  setSelectedLevel,
  setSelectedFact,
  setSelectedTypeProjectData,
  setCurrentPage,
  setRawData,
} from "../../../../redux/slices/reportDBRawDataSlice";
import { TableDBRawData } from "../../../../Components/Fragments/Tables/TableReportDBRawData";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import { BootstrapButton } from "../../../../Components/Button/BootstrapButton";
import ButtonGroup from "@mui/material/ButtonGroup";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import TextField from "@mui/material/TextField";
import "../../../../style/reportdbrawdata.css";
import { Slide, toast } from "react-toastify";

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function ReportProjectedRawData() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = useSelector((state) => state.general.accessToken);
  const dataProfile = {
    initial: useSelector((state) => state.profile.initial),
    role_code: useSelector((state) => state.profile.role_code),
  };

  //Pagination
  const itemsPerPage = useSelector((state) => state.rawData.itemsPerPage);
  const itemsPerPageList = [5, 10, 50, 100];

  //Type Project
  const [selectedTypeProject, setSelectedTypeProject] = useState("");
  const type_projects = useSelector((state) => state.rawData.type_projects);

  //Period
  const [selectedPeriodCheckBox, setSelectedPeriodCheckBox] = useState([]);
  const periods = useSelector((state) => state.rawData.periods);

  //Market Break Down
  const [selectedMarketBreakDownCheckBox, setSelectedMarketBreakDownCheckBox] =
    useState([]);
  const market_breakdowns = useSelector(
    (state) => state.rawData.market_breakdowns
  );

  //Level
  const [selectedLevelCheckBox, setSelectedLevelCheckBox] = useState([]);
  const levels = useSelector((state) => state.rawData.levels);

  //Fact
  const [selectedFactCheckBox, setSelectedFactCheckBox] = useState([]);
  const facts = useSelector((state) => state.rawData.facts);

  const [columnName, setColumnName] = useState("");
  const [columnValue, setColumnValue] = useState("");

  const columns = [
    { value: "", label: "Select Column" },
    { value: "rptID", label: "Report ID" },
    { value: "rpt_shortdesc", label: "Report Short Description" },
    { value: "rpt_longdesc", label: "Report Long Description" },
    { value: "FactValue", label: "Fact Value" },
    { value: "Group", label: "Group" },
    { value: "Principal", label: "Principal" },
    { value: "Brand", label: "Brand" },
    { value: "PackSize", label: "Pack Size" },
    { value: "PackType", label: "Pack Type" },
    { value: "Flavour", label: "Flavour" },
    { value: "Product", label: "Product" },
  ];
  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProfile(dispatch, accessToken);
      fetchTypeProjectNew(dispatch, accessToken, setSelectedTypeProject);
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, [dispatch, accessToken]);

  useEffect(() => {
    // Fetch initial data when type project changes
    if (selectedTypeProject) {
      fetchFact(
        dispatch,
        accessToken,
        selectedTypeProject,
        setSelectedFactCheckBox
      );
      fetchPeriod(
        dispatch,
        accessToken,
        selectedTypeProject,
        setSelectedPeriodCheckBox
      );
      fetchLevel(
        dispatch,
        accessToken,
        selectedTypeProject,
        setSelectedLevelCheckBox
      );
      fetchMarketBreakDown(
        dispatch,
        accessToken,
        selectedTypeProject,
        setSelectedMarketBreakDownCheckBox
      );
    }
  }, [dispatch, accessToken, selectedTypeProject]);

  const handleTypeProject = (event) => {
    const value = event.target.value;
    setSelectedTypeProject(value);

    dispatch(setSelectedTypeProjectData(value));

    fetchFact(dispatch, accessToken, value);
    fetchPeriod(dispatch, accessToken, value);
    fetchLevel(dispatch, accessToken, value);
    fetchMarketBreakDown(dispatch, accessToken, value);

    setSelectedFactCheckBox([]);
    setSelectedPeriodCheckBox([]);
    setSelectedLevelCheckBox([]);
    setSelectedMarketBreakDownCheckBox([]);
    // reset data of report db raw data
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDataReadyShow(
        selectedFactCheckBox,
        selectedPeriodCheckBox,
        selectedLevelCheckBox,
        selectedMarketBreakDownCheckBox,
        columnName,
        columnValue
      );
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, [
    selectedFactCheckBox,
    selectedPeriodCheckBox,
    selectedLevelCheckBox,
    selectedMarketBreakDownCheckBox,
    columnName,
    columnValue,
  ]);

  const setDataReadyShow = (
    selectedFactCheckBox,
    selectedPeriodCheckBox,
    selectedLevelCheckBox,
    selectedMarketBreakDownCheckBox,
    columnName,
    columnValue
  ) => {
    // validate when all column is fill (fact, period, level and market breakdown)
    if (
      selectedFactCheckBox.length > 0 &&
      selectedPeriodCheckBox.length > 0 &&
      selectedLevelCheckBox.length > 0 &&
      selectedMarketBreakDownCheckBox.length > 0
    ) {
      // call api report db raw data
      fetchData(
        selectedTypeProject,
        selectedFactCheckBox,
        selectedPeriodCheckBox,
        selectedLevelCheckBox,
        selectedMarketBreakDownCheckBox,
        columnName,
        columnValue
      );
    } else {
      dispatch(setRawData([]));
    }
  };

  // const handleFact = (event) => {
  //   const value = event.target.value;
  //   setSelectedFactCheckBox(value);

  //   const optionListString = value.toString();
  //   dispatch(setSelectedFact(optionListString));
  // };

  const handleFact = (event) => {
    const value = event.target.value;
    let updatedSelectedFactCheckBox = [];

    if (value.includes("selectAll")) {
      updatedSelectedFactCheckBox =
        selectedFactCheckBox.length === facts.length
          ? []
          : facts.map((fact) => fact.id);
    } else {
      updatedSelectedFactCheckBox = value.filter((val) => val !== "selectAll");
    }

    setSelectedFactCheckBox(updatedSelectedFactCheckBox);

    const optionListString = value.toString();
    dispatch(setSelectedFact(optionListString));
  };

  const handlePeriod = (event) => {
    const value = event.target.value;
    let updatedSelectedPeriodCheckBox = [];

    if (value.includes("selectAll")) {
      updatedSelectedPeriodCheckBox =
        selectedPeriodCheckBox.length === periods.length
          ? []
          : periods.map((period) => period.id);
    } else {
      updatedSelectedPeriodCheckBox = value.filter(
        (val) => val !== "selectAll"
      );
    }

    setSelectedPeriodCheckBox(updatedSelectedPeriodCheckBox);

    const optionListString = updatedSelectedPeriodCheckBox.toString();
    dispatch(setSelectedPeriod(optionListString));
  };

  const handleLevel = (event) => {
    const value = event.target.value;
    let updatedSelectedLevelCheckBox = [];

    if (value.includes("selectAll")) {
      updatedSelectedLevelCheckBox =
        selectedLevelCheckBox.length === levels.length
          ? []
          : levels.map((level) => level.id);
    } else {
      updatedSelectedLevelCheckBox = value.filter((val) => val !== "selectAll");
    }

    setSelectedLevelCheckBox(updatedSelectedLevelCheckBox);

    const optionListString = value.toString();
    dispatch(setSelectedLevel(optionListString));
  };

  const handleMarketBreakDown = (event) => {
    const value = event.target.value;
    let updatedSelectedMarketBreakDownCheckBox = [];

    if (value.includes("selectAll")) {
      updatedSelectedMarketBreakDownCheckBox =
        selectedMarketBreakDownCheckBox.length === market_breakdowns.length
          ? []
          : market_breakdowns.map((market_breakdown) => market_breakdown.id);
    } else {
      updatedSelectedMarketBreakDownCheckBox = value.filter(
        (val) => val !== "selectAll"
      );
    }

    setSelectedMarketBreakDownCheckBox(updatedSelectedMarketBreakDownCheckBox);

    const optionListString = value.toString();
    dispatch(setSelectedMarketBreakDown(optionListString));
  };

  const fetchData = async (
    selectedTypeProject,
    selectedFactCheckBox,
    selectedPeriodCheckBox,
    selectedLevelCheckBox,
    selectedMarketBreakDownCheckBox,
    columnName,
    columnValue
  ) => {
    try {
      dispatch(setCurrentPage(1));
      let customParams = {
        size: itemsPerPage,
        page: 1,
        db_set: selectedTypeProject,
        fact: selectedFactCheckBox,
        period: selectedPeriodCheckBox,
        level: selectedLevelCheckBox,
        market_breakdown: selectedMarketBreakDownCheckBox,
      };

      if (columnName && columnValue) {
        customParams.column_name = columnName;
        customParams.column_value = columnValue;
      };
      await fetchRawData(dispatch, accessToken, customParams);
    } catch (error) {
      console.error(`Error fetching data:`, error);
    }
  };

  const reportDBRawData = (...arrays) => {
    return arrays.some((array) => array.length === 0);
  };

  const goToPivot = () => {
    window.location.replace("/projected-reporting");
  };

  async function handleProcessExport() {
    setIsLoading(true);
    try {
      const formData = {
        db_set: selectedTypeProject,
        // fact: selectedFactCheckBox,
        fact: Array.isArray(selectedFactCheckBox)
        ? selectedFactCheckBox.join(",")
        : selectedFactCheckBox,
        period: Array.isArray(selectedPeriodCheckBox)
          ? selectedPeriodCheckBox.join(",")
          : selectedPeriodCheckBox,
        level: Array.isArray(selectedLevelCheckBox)
          ? selectedLevelCheckBox.join(",")
          : selectedLevelCheckBox,
        market_breakdown: Array.isArray(selectedMarketBreakDownCheckBox)
          ? selectedMarketBreakDownCheckBox.join(",")
          : selectedMarketBreakDownCheckBox,
      };

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/report_db/process_queue`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(formData),
        }
      );

      if (
        response.status === 201 ||
        response.status === 200 ||
        response.status === 202
      ) {
        toast.success("data akan diproses kedalam antrian", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else if (response.status === 400) {
        const message = await response.json();
        toast.error(message?.detail, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else if (response.status === 404) {
        toast.error("data tidak ditemukan", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        toast.error("ada masalah saat menyimpan data", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      }
    } catch (error) {
      console.error("Error creating process queue:", error);
    }
    setIsLoading(false);
  }

  const handleExport = async () => {
    setIsLoading(true);
    try {
      const formData = {
        db_set: selectedTypeProject,
        // fact: Array.isArray(selectedFactCheckBox)
        // ? selectedFactCheckBox.join(",")
        // : selectedFactCheckBox,
        fact: Array.isArray(selectedFactCheckBox) 
          ? selectedFactCheckBox[0]
          : selectedFactCheckBox,
        level: Array.isArray(selectedLevelCheckBox)
          ? selectedLevelCheckBox.join(",")
          : selectedLevelCheckBox,
        period: Array.isArray(selectedPeriodCheckBox)
          ? selectedPeriodCheckBox.join(",")
          : selectedPeriodCheckBox,
        market_breakdown: Array.isArray(selectedMarketBreakDownCheckBox)
          ? selectedMarketBreakDownCheckBox.join(",")
          : selectedMarketBreakDownCheckBox,
      };

      const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/report_db/export`;

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 200) {
        const blob = await response.blob();
        const filename = `report_rawdata_${selectedLevelCheckBox}_${selectedTypeProject}_${selectedFactCheckBox}.xlsx`;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
      } else if (response.status === 400 || response.status === 404) {
        const data = await response.json();
        toast.error(data.detail, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        toast.error("Gagal mengunduh", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        console.error("Failed to export process queue:", response.statusText);
      }
    } catch (error) {
      console.error("Error export process queue:", error);
    }
    setIsLoading(false);
  };

  return (
    <div>
      <Navbar
        active="Projected Reporting"
        initial={dataProfile.initial}
        role_code={dataProfile.role_code}
      />
      <div style={{ padding: "2rem" }}>
        <Box sx={{ display: "block" }}>
          <Box className="container-textfield" sx={{ mt: "30px", mb: "-40px" }}>
            <Box className="content-text" sx={{ textAlign: "center" }}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: 20,
                  fontFamily: "Montserrat",
                  fontWeight: 700,
                }}
              >
                Projected Report - Tabular
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: {
              sm: "flex-end",
              xs: "center",
            },
          }}
        >
          <ButtonGroup style={{ color: "white" }}>
            <BootstrapButton
              onClick={goToPivot}
              style={{
                color: "white",
                borderColor: "white",
                height: "40px",
                width: "fit-content",
              }}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Go to Pivot Report View"}
            </BootstrapButton>
            <BootstrapButton
              onClick={handleProcessExport}
              style={{
                color: "white",
                borderColor: "white",
                height: "40px",
                width: "100px",
              }}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Process"}
            </BootstrapButton>
            <BootstrapButton
              onClick={handleExport}
              style={{
                color: "white",
                borderColor: "white",
                height: "40px",
                width: "100px",
              }}
            >
              {isLoading ? "Loading..." : "Download"}
            </BootstrapButton>
          </ButtonGroup>
        </Box>

        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "40px"}}>
          <div className="form-raw-data">
            <FormControl sx={{ mb: 2, mt: 1, mr: 2, width: 160 }} size="small">
              <InputLabel
                id="demo-multiple-checkbox-label"
                sx={{ fontSize: "16px" }}
              >
                DB Set Name
              </InputLabel>
              <Select
                id="type-project-autocomplete"
                label="DB Set Name"
                select
                value={selectedTypeProject}
                onChange={handleTypeProject}
                size="small"
              >
                {type_projects.map((db_set) => (
                  <MenuItem key={db_set.id} value={db_set.id} sx={{ fontSize: "13px", minHeight: "28px" }}>
                    {db_set.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* <FormControl sx={{ mb: 2, mt: 1, mr: 2, width: 250 }}>
              <InputLabel
                id="demo-multiple-checkbox-label"
                style={{ fontSize: "16px" }}
              >
                Fact
              </InputLabel>
              <Select
                id="fact-autocomplete"
                select
                label="Fact"
                value={selectedFactCheckBox}
                onChange={(event) =>
                  handleFact(event, { id: event.target.value })
                }
              >
                {facts.map((fact) => (
                  <MenuItem key={fact.id} value={fact.id}>
                    {fact.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
            <FormControl sx={{ mb: 2, mt: 1, mr: 2, width: 200 }} size="small">
              <InputLabel
                id="demo-multiple-checkbox-label"
                style={{ fontSize: "16px" }}
              >
                Fact
              </InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                label="Fact"
                id="demo-multiple-checkbox"
                multiple
                value={selectedFactCheckBox}
                onChange={handleFact}
                size="small"
                // input={<OutlinedInput label="fact" />}
                renderValue={(selected) => {
                  if (typeof selected === "string") {
                    return selected;
                  }
                  return selected.join(",");
                }}
                MenuProps={MenuProps}
              >
                <MenuItem key="selectAll" value="selectAll" sx={{ fontSize: "13px", minHeight: "28px" }}>
                  <Checkbox
                    checked={selectedFactCheckBox.length === facts.length}
                  />
                  <ListItemText primary="Select All" />
                </MenuItem>
                {facts.map((fact) => (
                  <MenuItem key={fact.id} value={fact.id} sx={{ fontSize: "13px", minHeight: "28px" }}>
                    <Checkbox
                      checked={selectedFactCheckBox.indexOf(fact.id) > -1}
                    />
                    <ListItemText primary={fact.label} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ mb: 2, mt: 1, mr: 2, width: 160 }} size="small">
              <InputLabel
                id="demo-multiple-checkbox-label"
                style={{ fontSize: "16px" }}
              >
                Period
              </InputLabel>
              <Select
                label="Period"
                id="demo-multiple-checkbox"
                multiple
                value={selectedPeriodCheckBox}
                onChange={handlePeriod}
                size="small"
                input={<OutlinedInput label="Period" />}
                renderValue={(selected) => {
                  if (typeof selected === "string") {
                    return selected;
                  }
                  return selected.join(",");
                }}
                MenuProps={MenuProps}
              >
                <MenuItem key="selectAll" value="selectAll" sx={{ fontSize: "13px", minHeight: "28px" }}>
                  <Checkbox
                    checked={selectedPeriodCheckBox.length === periods.length}
                  />
                  <ListItemText primary="Select All" />
                </MenuItem>
                {periods.map((period) => (
                  <MenuItem key={period.id} value={period.id} sx={{ fontSize: "13px", minHeight: "28px" }}>
                    <Checkbox
                      checked={selectedPeriodCheckBox.indexOf(period.id) > -1}
                    />
                    <ListItemText primary={period.label} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ mb: 2, mt: 1, mr: 2, width: 160 }} size="small">
              <InputLabel
                id="demo-multiple-checkbox-label"
                style={{ fontSize: "16px" }}
              >
                Level
              </InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                label="Level"
                id="demo-multiple-checkbox"
                multiple
                value={selectedLevelCheckBox}
                onChange={handleLevel}
                size="small"
                // input={<OutlinedInput label="level" />}
                renderValue={(selected) => {
                  if (typeof selected === "string") {
                    return selected;
                  }
                  return selected.join(",");
                }}
                MenuProps={MenuProps}
              >
                <MenuItem key="selectAll" value="selectAll" sx={{ fontSize: "13px", minHeight: "28px" }}>
                  <Checkbox
                    checked={selectedLevelCheckBox.length === levels.length}
                  />
                  <ListItemText primary="Select All" />
                </MenuItem>
                {levels.map((level) => (
                  <MenuItem key={level.id} value={level.id} sx={{ fontSize: "13px", minHeight: "28px" }}>
                    <Checkbox
                      checked={selectedLevelCheckBox.indexOf(level.id) > -1}
                    />
                    <ListItemText primary={level.label} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ mb: 2, mt: 1, mr: 2, width: 200 }} size="small">
              <InputLabel
                id="demo-multiple-checkbox-label"
                style={{ fontSize: "16px" }}
              >
                Market Breakdown
              </InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                label="Market_Breakdown"
                id="demo-multiple-checkbox"
                multiple
                value={selectedMarketBreakDownCheckBox}
                onChange={handleMarketBreakDown}
                size="small"
                renderValue={(selected) => {
                  if (typeof selected === "string") {
                    return selected;
                  }
                  return selected.join(",");
                }}
                MenuProps={MenuProps}
              >
                <MenuItem key="selectAll" value="selectAll" sx={{ fontSize: "13px", minHeight: "28px" }}>
                  <Checkbox
                    checked={
                      selectedMarketBreakDownCheckBox.length ===
                      market_breakdowns.length
                    }
                  />
                  <ListItemText primary="Select All" />
                </MenuItem>
                {market_breakdowns.map((market_breakdown) => (
                  <MenuItem
                    key={market_breakdown.id}
                    value={market_breakdown.id}
                    sx={{ fontSize: "13px", minHeight: "28px" }}
                  >
                    <Checkbox
                      checked={
                        selectedMarketBreakDownCheckBox.indexOf(
                          market_breakdown.id
                        ) > -1
                      }
                    />
                    <ListItemText primary={market_breakdown.label} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl size="small" sx={{ mb: 2, mt: 1, mr: 2, width: 160 }}>
              <InputLabel
                id="column-name-label"
                style={{ fontSize: "16px" }}
              >
                Column Name
              </InputLabel>
              <Select
                size="small"
                labelId="column-name-label"
                label="Column Name"
                value={columnName}
                onChange={(e) => setColumnName(e.target.value)}
              >
                {columns.map((col) => (
                  <MenuItem key={col.value} value={col.value} sx={{ fontSize: "13px", minHeight: "28px" }}>
                    {col.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              size="small"
              label="Column Value"
              variant="outlined"
              value={columnValue}
              disabled={columnName === ""}
              onChange={(e) => setColumnValue(e.target.value)}
              sx={{ mb: 2, mt: 1, mr: 2, width: 200 }}
              InputProps={{
                endAdornment: (
                  <>
                    {columnValue && (
                      <IconButton
                        onClick={() => {
                          setColumnValue("");
                        }}
                      >
                        <ClearIcon />
                      </IconButton>
                    )}
                  </>
                ),
              }}
            />
          </div>
        </div>

        {!reportDBRawData(
          selectedFactCheckBox,
          selectedPeriodCheckBox,
          selectedLevelCheckBox,
          selectedMarketBreakDownCheckBox
        ) && (
          <TableDBRawData
            itemsPerPageList={itemsPerPageList}
            selectedTypeProject={selectedTypeProject}
            selectedFact={selectedFactCheckBox}
            selectedPeriod={selectedPeriodCheckBox}
            selectedLevel={selectedLevelCheckBox}
            selectedMarketBreakDown={selectedMarketBreakDownCheckBox}
            columnName={columnName}    
            columnValue={columnValue} 
          />
        )}
      </div>
    </div>
  );
}
